import { render, staticRenderFns } from "./Sofort.vue?vue&type=template&id=7fbc4b7e&scoped=true"
import script from "./Sofort.vue?vue&type=script&lang=js"
export * from "./Sofort.vue?vue&type=script&lang=js"
import style0 from "./Sofort.vue?vue&type=style&index=0&id=7fbc4b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc4b7e",
  null
  
)

export default component.exports